import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import type { TLlmTechnicalDetails } from '@/_core/entities/vulnerability/models/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'VulnerabilityTechnicalDetails',
  props: {
    technicalDetails: null
  },
  setup(__props: any) {

const props = __props as {
  technicalDetails: TLlmTechnicalDetails | null;
};



const summaryText = computed(() => props.technicalDetails?.summary ?? null);

return { __sfc: true,props, summaryText }
}

})